import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import AboutRelationship from '../AboutRelationship/AboutRelationship';

import CharityRegNumber from '../CharityRegNumber/CharityRegNumber';
import PageListMini from '../PageList/PageListMini';
import PageSection from '../PageSection/PageSection';

const AboutCharityMini: FunctionComponent<CharityMini> = ({
  totalCount,
  charities,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  if (totalCount === 1) {
    const [{ url, logo, title, impactStatement }] = charities;
    return (
      <>
        <AboutRelationship
          landingPageUrl={url}
          logo={logo}
          name={title}
          description={impactStatement}
          inline
        >
          <CharityRegNumber className="jg-space-mbn" />
        </AboutRelationship>
      </>
    );
  }

  return (
    <PageSection
      title={t('page.charitysMiniTitle')}
      className="jg-pages-aboutownermini"
      count={totalCount}
    >
      <PageListMini pages={charities} totalCount={totalCount} />
    </PageSection>
  );
};

interface CharityMini {
  totalCount: number;
  charities: {
    id: string;
    title: string;
    logo?: string;
    url: string;
    impactStatement: string;
  }[];
}

export default AboutCharityMini;
